import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ApiUrl from '../api'; // Adjust path as needed
import { Helmet } from "react-helmet";
import ProductFilter from "./Products/modules/ProductFilter";

const CustomPage = ({ handleCart, handleWishlist }) => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loginData, setLoginData] = useState(null);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [selectedFilters, setSelectedFilters] = useState({});

  useEffect(() => {
    const userData = sessionStorage.getItem("user_data");
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        setLoginData(parsedData);
      } catch {
        setLoginData(null);
      }
    }
  }, []);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await ApiUrl.get(`/pages/${slug}?page=${currentPage}`);
        setPage(response.data.page);
        setProducts(response.data.data);
        setLastPage(response.data.meta?.last_page || 1);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug, currentPage]);

  const handleFilterChange = (filters) => {
    setSelectedFilters(filters);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage) {
      setCurrentPage(page);
      setLoading(true);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error || !page) return <p>Page not found.</p>;

  return (
    <>
      <Helmet>
        <title>{page.meta_title}</title>
        <meta name="title" content={page.meta_title} />
        <meta name="description" content={page.meta_description} />
      </Helmet>

      {/* Page Title Section */}
      <section
        style={{
          background: 'none',
          padding: '60px 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <div className="container-fluid">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="title-outer">
                <h1 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '10px' }}>
                  {page.title}
                </h1>
                <h2 style={{ fontSize: '20px', color: '#555' }}>{page.short_desc}</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <ProductFilter onFilterChange={handleFilterChange} onResetFilters={() => handleFilterChange({})} />

      {/* Products Section */}
      <section className="products-section">
        <div className="container-fluid">
          <div className="row">
            {products?.map((product) => (
              <div className="product-block col-lg-4 col-md-6 col-sm-6 col-12" key={product.id}>
                <div className="inner-box">
                  <div className="image">
                    <Link to={`/products/${product.slug}`}>
                      <img src={product.thumbnail_image} alt={product.name} />
                    </Link>
                    {product.discount !== 0 && (
                      <div className="product-success">{product.discount}% Off</div>
                    )}
                  </div>

                  <div className="product-made">
                    {product.stock_quantity === 0 ? (
                      <span className="text-danger">Out Of Stock</span>
                    ) : (
                      <span>MADE TO ORDER</span>
                    )}
                  </div>

                  <div className="content-box">
                    <Link to={`/products/${product.slug}`} className="buy-btn">
                      BUY NOW
                    </Link>
                    <Link
                      to="#"
                      onClick={() =>
                        handleCart(product.id, "", loginData?.id, 1)
                      }
                      className="cart-btn"
                    >
                      ADD TO CART
                    </Link>
                  </div>

                  <div className="content">
                    <h4>
                      <Link to={`/products/${product.slug}`}>{product.name}</Link>
                    </h4>
                    <span className="price">
                      {product.stocked_price !== product.main_price && (
                        <del>{product.stocked_price}</del>
                      )}
                      &nbsp;{product.main_price}
                    </span>
                  </div>

                  <div className="icon-box">
                    {loginData ? (
                      <Link
                        to="#"
                        onClick={() => handleWishlist(product.slug)}
                        className="ui-btn like-btn"
                        aria-label="Add to Wishlist"
                      >
                        <i className="fa fa-heart"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/login"
                        className="ui-btn add-to-cart"
                        aria-label="Login to Add to Cart"
                      >
                        <i className="fa fa-heart"></i>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {lastPage > 1 && (
            <div className="row mt-4">
              <div className="col-xl-12">
                <div className="project-details__pagination-box">
                  <ul className="project-details__pagination list-unstyled clearfix">
                    <li className="previous">
                      <div className="icon">
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          aria-label="Previous"
                        >
                          <i className="lnr lnr-icon-arrow-left"></i>
                        </button>
                      </div>
                    </li>
                    <li className="count px-3">
                      <span>Page {currentPage} of {lastPage}</span>
                    </li>
                    <li className="next">
                      <div className="icon">
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === lastPage}
                          aria-label="Next"
                        >
                          <i className="lnr lnr-icon-arrow-right"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Description Section */}
      <section className="custom-description-section py-5">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* <h2 className="mb-3">Description</h2> */}
              <div
                className="description-content"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomPage;
